import React, { Component } from 'react'
import { Meta, getmeta, Feature, collectFeatureOptions, createDefaultFeatureLabel } from '../../common'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Button, Grid } from 'semantic-ui-react'
import InputFeatureType from './InputFeatureType'


interface BatchDeleteFeatureProps extends WithTranslation {
    meta: Meta,
    formik: any,
    f: Feature,
    index: number,
    prefix: string,
    cunitTypes: string[]|null
}

class BatchDeleteFeature extends Component<BatchDeleteFeatureProps> {

    componentDidMount() {
    }

    render() {
        const { f, index, cunitTypes, prefix, formik, meta, t, i18n } = this.props

        if (!meta['cats']) return null
        const fmeta = getmeta(meta, 'feature', f.type)

        const features = collectFeatureOptions(meta, cunitTypes, null, null, true, true, true)
        const typeOptions = features.map(f => ({key: f.type, text: createDefaultFeatureLabel(meta, f.type, true), value: f.type}))
        return(
            <>
            <Grid.Row className="condensed">
                <InputFeatureType name={prefix+'.type'} fmeta={fmeta} options={typeOptions} widthCols={10}/>
                <Grid.Column width={5}>
                </Grid.Column>
                <Grid.Column width={1} textAlign="right">
                    <Button icon="delete" type="button" size='mini' color='red' 
                        onClick={(e,d) => formik.remove(index)}/>
                </Grid.Column>
            </Grid.Row>
            </>
        )
    }

}

export default withTranslation()(BatchDeleteFeature)